import React, { Component } from 'react';
import { history } from 'store';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import TextField from 'material-ui/TextField';

class RegistrationForm extends Component {
  state = {
    email: this.props.email,
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
    error: ''
  }

  handleFieldChange = e => this.setState({ [e.target.name]: e.target.value });

  handleSubmit = e => {
    e.preventDefault();
    // validate passwords match
    if (this.state.password == this.state.confirmPassword) {
      this.props.createUser(this.state).then(success => {
        if (success) {
          this.props.hideModal();
          // history.push("/profile");
        }
      });
    } else {
      this.setState({error: 'Passwords do not match.'});
    }
    
  }

  render() {
    return (
      <form name="register">
        <TextField 
          type="email"
          name="email"
          label="email"
          margin="normal"
          value={this.state.email} 
          onChange={this.handleFieldChange}
          fullWidth 
        />
        <TextField 
          type="text"
          name="firstName"
          label="First Name"
          margin="normal"
          value={this.state.firstName} 
          onChange={this.handleFieldChange}
          fullWidth
        />
        <TextField 
          type="text"
          name="lastName"
          label="Last Name"
          margin="normal"
          value={this.state.lastName} 
          onChange={this.handleFieldChange}
          fullWidth
        />
        <TextField 
          type="password"
          name="password"
          label="Password"
          margin="normal"
          value={this.state.password} 
          onChange={this.handleFieldChange}
          fullWidth
        />
        <TextField 
          type="password"
          name="confirmPassword"
          label="Confirm Password"
          margin="normal"
          value={this.state.confirmPassword} 
          onChange={this.handleFieldChange}
          fullWidth
        />
        {this.state.error !== "" ? <Typography color="contrast">{this.state.error}</Typography> : null}
        <Button
          variant="raised"
          color="primary"
          style={{width: '100%'}}
          onClick={(e) => this.handleSubmit(e)}
        >Create Account</Button>
      </form>
    )
  }
}

export default RegistrationForm;


// WEBPACK FOOTER //
// ./routes/Modal/Register/components/RegistrationForm/index.jsx